import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../../../components/Button/Button';
import FaqPopup from '../../../../components/FaqPopup/FaqPopup';
import { QuestionBubbleIcon } from '../../../../components/Icon/Icon';
import { SectionTitleStyled } from '../../HomePage.styled';
import { EchoImgStyled, FaqButtonWrapperStyled, LogoStyled } from './Imppact.styled';

type ImppactPropsT = {
  logoUrl: string;
  isTransportType: boolean;
  isWayajCustomer: boolean;
};

const Imppact: React.FC<ImppactPropsT> = ({ logoUrl, isTransportType, isWayajCustomer }) => {
  const [isFaqPopupOpen, setIsFaqPopupOpen] = useState(false);

  return (
    <>
      <div>
        <SectionTitleStyled level={3} align="center">
          <FormattedMessage
            id="home.travelSection.title"
            defaultMessage="Travel With IMPPACT\u2122"
          />
        </SectionTitleStyled>

        <FormattedMessage
          id="home.travelSection.text1"
          values={{
            p: (...chunks: string[]) => <p>{chunks}</p>,
          }}
        />

        {!isWayajCustomer && (
          <>
            <LogoStyled src={logoUrl} alt="customer-logo" />
            <p>
              {isTransportType ? (
                <FormattedMessage
                  id="home.travelSection.partnershipText.transportationAndSustainabilityType"
                  defaultMessage="Our partnership with Wayaj is important in extending what we feel is vital to supporting sustainability. Please, tell your friends and family they can now easily contribute to the health of our planet and participate in supporting valuable initiatives in our community and around the world."
                />
              ) : (
                <FormattedMessage
                  id="home.travelSection.partnershipText.otherType"
                  defaultMessage="Our hotel and staff members are committed to protecting and preserving the environment. Our partnership with Wayaj is important in extending what we feel is vital to supporting sustainability. Please, tell your friends and family they can now easily contribute to the health of our planet and participate in supporting valuable initiatives in our community and around the world."
                />
              )}
            </p>
          </>
        )}

        <EchoImgStyled src={'/images/logo_wayaj.png'} alt="logo_wayaj" />

        <FormattedMessage
          id="home.travelSection.text2"
          values={{
            p: (...chunks: string[]) => <p>{chunks}</p>,
          }}
        />
      </div>

      <FaqButtonWrapperStyled>
        <Button onClick={() => setIsFaqPopupOpen(true)}>
          <FormattedMessage id="button.FAQ" defaultMessage="FAQ" />
          <QuestionBubbleIcon />
        </Button>
      </FaqButtonWrapperStyled>

      <FaqPopup isOpen={isFaqPopupOpen} onClose={() => setIsFaqPopupOpen(false)} />
    </>
  );
};

export default Imppact;
